import React, { useState } from "react";

// Material UI Components
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";

// Components
import EmailLogsHeader from "./EmailLogsHeader";
import EmailLogsBody from "./EmailLogsBody";
import Paginate from "../../../../../Utilities/Paginate";

// This component will hold the latest leads data
const EmailLogsTable = ({
  emailLogs,
  open,
  allCustomerData,
  setUpdatedData,
  setTrigger,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const createData = (email, sentDate, subject, category, status, body) => {
    return {
      email,
      sentDate,
      subject,
      category,
      status,
      body,
    };
  };
  const EmailLogs = emailLogs.map(
    ({ email, sentDate, subject, category, status, body }) =>
      createData(email, sentDate, subject, category, status, body)
  );
  return (
    <div className={`defaulted ${open ? "show-table" : "hide-table"}`}>
      <TableContainer>
        <Table className="table" size={"small"}>
          <EmailLogsHeader />
          <EmailLogsBody
            emailLogs={EmailLogs}
            page={page}
            rowsPerPage={rowsPerPage}
            allCustomerData={allCustomerData}
            setUpdatedData={setUpdatedData}
            setTrigger={setTrigger}
          />
        </Table>
      </TableContainer>
      {emailLogs.length > rowsPerPage ? 
        <Paginate totalRowCount={emailLogs.length} page={page} rowsPerPage={rowsPerPage} handleChange={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} showCorePaginate={true} />
        : null
      }
      <div className="bottom-footer"></div>
    </div>
  );
};

export default EmailLogsTable;
